module.exports = "/shared/img/menu-right.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/menu-right.svg
// module id = 444
// module chunks = 13